import { LinkType, Proximity } from '../linked-accounts/linked-accounts.model';

export interface CheckedFields {
  firstName?: boolean;
  lastName?: boolean;
  email?: boolean;
  dob?: boolean;
  mobile?: boolean;
  houseNo?: boolean;
  postcode?: boolean;
}

export interface DuplicateCheckLink {
  checkId: number;
  pid: number;
  outcome?: ChildLinkOutcome;
  firstName: string;
  lastName: string;
  email: string;
  dob: string;
  mobile: string;
  houseNo: string;
  postcode: string;
  registered: Date;
  status: string;
  seonScore: number;
  reason: string;
  actionedBy: string;
  actionedDate: Date;
  linkChecked?: boolean;
  existingLink?: ExistingLink;
  checkedFields?: CheckedFields;
}

export interface ExistingLink {
  relation: Proximity;
  type: LinkType;
}

export interface DuplicateCheckUnlock {
  checkId: number;
}

export interface DuplicateCheckLock {
  email: string;
  fullName: string;
  currentOperator?: boolean;
}

export interface DuplicateCheck {
  id: number;
  pid: number;
  lockedBy?: DuplicateCheckLock;
  firstName: string;
  lastName: string;
  email: string;
  dob: string;
  mobile: string;
  houseNo: string;
  postcode: string;
  registered: Date;
  status: string;
  seonScore: number;
  trigger: string;
  created: Date;
  finished?: Date;
  resolutionStatus?: ResolutionStatus;
  checkedFields?: CheckedFields;
  children?: DuplicateCheckLink[];
  expanded?: boolean;
  hasAnyChildChecked?: boolean;
  forceExpanded?: boolean;
  archivedDate?: Date;
}

export interface CheckedLinkToBeActioned {
  parentId: number;
  parentPlayerId: number;
  linkId: number;
  linkPlayerId: number;
}

export interface DuplicateCheckFilters {
  playerId?: string;
  email?: string;
  lastName?: string;
  outcome?: string;
  agentEmail?: string;
}

export interface DuplicateChecksQueryParams {
  pageNumber: number;
  pageSize: number;
  sortField?: string;
  sortDirection?: string;
}

export enum ResolutionStatus {
  MANUAL_MITIGATION = 'Manual mitigation',
  MANUAL_DUPLICATE = 'Manual duplicate',
  AUTO_DUPLICATE = 'Auto duplicate',
  MANUAL_SIMILARITY = 'Manual similarity',
  AUTO_PAR = 'Auto PAR',
  AUTO_MITIGATION = 'Auto mitigation',
}

export enum ChildLinkOutcome {
  MITIGATED = 'Mitigated',
  LINKED_SIMILAR_DETAILS = 'Similar details',
  LINKED_HOUSEHOLD = 'Household',
  LINKED_DUPLICATE = 'Duplicate',
  LINKED_PAR = 'PAR',
  LINKED_DUPLICATE_WITH_STATUS_CHANGE = 'Linked duplicate with status change',
}

export enum DuplicateCheckTrigger {
  REGISTRATION = 'Registration',
  SG_STATUS_CHANGE = 'SG status change',
  CARD_PAR = 'Card PAR',
  PERSONAL_INFO_UPDATE = 'Personal info update',
}

export interface ChildEntryAction {
  childPlayerId: number;
  outcome: ChildLinkOutcome;
  reason: string;
}

export interface ActionChildEntriesRequest {
  checkId: number;
  childActions: ChildEntryAction[];
}

export interface ActionChildEntriesResponse {
  checkId: number;
  playerId: number;
  outcome: string | null;
  archived: boolean;
}
